/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-14 11:07:49
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Icon } from '@shopify/polaris';
import { NoteMinor, CircleTickOutlineMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  fileName: string,
  fileSize: number,
  total: number
};

type ComposedProps = Props & WithI18nProps;

class ImportDetails extends Component<ComposedProps> {
  render() {
    // Status = 'details' || 'complete'
    const { i18n, status, fileName, fileSize, total } = this.props;

    const details =
      status === 'details' ? (
        <div>
          <p style={{ fontWeight: 600, marginTop: '1.5rem', marginBottom: '0.5rem' }}>
            {i18n.translate('AdminHTML.Common.Title.details')}
          </p>
          <p>
            {i18n.translate('AdminHTML.SuggestionDictionary.Import.importDetail', {
              count: total,
              nt_total: total
            })}
          </p>
        </div>
      ) : (
        <div>
          <p style={{ fontWeight: 600, marginTop: '1.5rem', marginBottom: '0.5rem' }}>
            {i18n.translate('AdminHTML.Common.Title.details')}
          </p>
          <div>
            <div style={{ float: 'left', height: '50px', padding: '10px 14px 0 0' }}>
              <Icon source={CircleTickOutlineMinor} color="success" />
            </div>
            <div>
              <p>{i18n.translate('AdminHTML.SuggestionDictionary.Import.newSuggestion')}</p>
              <p>
                {i18n.translate('AdminHTML.SuggestionDictionary.Import.importMessage', {
                  count: total,
                  t1: (
                    <strong>
                      {i18n.translate('AdminHTML.SuggestionDictionary.Import.importMessage_t1', {
                        count: total,
                        nt_total: total
                      })}
                    </strong>
                  )
                })}
              </p>
            </div>
          </div>
        </div>
      );
    return (
      <React.Fragment>
        <div style={{ textAlign: 'center' }}>
          <Icon source={NoteMinor} />
          <div style={{ padding: '0.375rem 0', fontWeight: 600 }}>{fileName}</div>
          <div>
            {i18n.translate('AdminHTML.Common.File.size', {
              count: fileSize,
              nt_number: i18n.formatNumber(fileSize)
            })}
          </div>
        </div>

        {/* File details */}
        {details}
      </React.Fragment>
    );
  }
}

export default withI18n()(ImportDetails);
